import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Chip from "@mui/material/Chip";
import {clearQuestionTemplateSearchTags} from "../actions/questionEditorActions";
import {setFilter} from "../actions/setFilter";
import { getIntegrationLogs } from "../actions/integrationLogsActions";
import {pageableObjFromFilter} from "../utilities/PageableAndFilterUtilities";
import * as TEMPLATE from "../constants/templateConstants";


const TableViewHook = (props) => {

    const deleteChip = (whichChip) => {
        // If a loading function was passed then call it to set the loading animation
        // because deleting a chip will do a call to server to get the list displayed with new filter conditions
        // NOTE: All lists should use loading animations
        if (typeof props.setLoadingState === "function") {
            props.setLoadingState(function () {}, null, "FILTER");
        }

        let filter = {...props.pageFilter};

        filter.pageNumber = 1;
        filter.title = props.pageFilter.title;
        filter.nameQualifier = props.pageFilter.nameQualifier;
        filter.updatedBy = props.pageFilter.updatedBy;
        filter.status = props.pageFilter.status;
        filter.questionType = props.pageFilter.questionType;
        filter.integrationType = props.pageFilter.integrationType;
        filter.outstanding = props.pageFilter.outstanding;
        filter.tags = props.pageFilter.tags;
        filter.pageSize = filter.pageSize === undefined ? 10 : filter.pageSize;
        filter.keyMetric = props.pageFilter.keyMetric
        filter.keyMetricIndex = props.pageFilter.keyMetricIndex

        switch(whichChip) {
            case "outstanding":
                filter[whichChip] = false;
                break;
            case "tags":
                props.clearQuestionTemplateSearchTags(2); // NOTE: Using question depth 2 to store tags in filter !!!
                filter[whichChip] = [];
                break;
            case "status":
                filter[whichChip] = 0
                break
            case "questionType":
                filter[whichChip] = "ALL"
                break
            case "keyMetric":
                filter.keyMetric = ""
                filter.keyMetricIndex = 0
                break
            default:
                filter[whichChip] = "";
        }

        props.setFilter(pageableObjFromFilter(filter), filter, props.templateType, props.templateMode);

        if (props.templateType === 'integrationLogs' && props.integrationID !== null) {
            props.getIntegrationLogs(props.integrationID, filter.name,
                {pageNumber: filter.pageNumber, pageSize: filter.pageSize, name: filter.name, direction: filter.direction},
                filter.ucid, filter.questionnaire);
        }
    };

    const filter = props.pageFilter;
    const chipBgColor = "#f2f2f2";

    return (
        <div id="TableView-chip-display-outer-div" style={{border: "1px solid lightgray", padding: "10px", boxShadow: "2px 4px whitesmoke"}}>
            <div id="TableView-chip-display-inner-div" style={{display: "flex",  justifyContent: "right"}}>
                {props.filter !== undefined ? <div style={{display: "inline-flex"}}>
                    <div style={{marginTop: '4px'}}>{filter.title ?
                        <Chip key={"title"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("title")} label={"Name"}/> : ""}</div>
                    <div style={{width: filter.title ? "6px" : "0px"}}/>
                    <div style={{marginTop: '4px'}}>{filter.nameQualifier ?
                        <Chip key={"nameQualifier"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("nameQualifier")} label={"Qualifier"}/> : ""}</div>
                    <div style={{width: filter.nameQualifier ? "6px" : "0px"}}/>
                    <div style={{marginTop: '4px'}}>{filter.status ?
                        <Chip key={'"status'} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("status")} label={"Status"}/> : ""}</div>
                    <div style={{width: filter.status ? "6px" : "0px"}}/>
                    <div style={{marginTop: '4px'}}>{filter.questionType !== "ALL" ?
                        <Chip key={"questionType"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("questionType")} label={"Question Type"}/> : ""}</div>
                    <div style={{width: filter.questionType ? "6px" : "0px"}}/>
                    <div style={{marginTop: '4px'}}>{filter.integrationType ?
                        <Chip key={"integrationType"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("integrationType")} label={"Integration Type"}/> : ""}</div>
                    <div style={{width: filter.integrationType ? "6px" : "0px"}}/>
                    <div style={{marginTop: '4px'}}>{filter.updatedBy ?
                        <Chip key={"updated"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("updatedBy")} label={"Updated By"}/> : ""}</div>
                    <div style={{width: filter.updatedBy ? "6px" : "0px"}}/>
                    <div style={{marginTop: '4px'}}>{filter.tags.length > 0 ?
                        <Chip key={"tags"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("tags")} label={"Tags"}/> : ""}</div>
                    <div style={{width: filter.tags.length > 0 ? "6px" : "0px"}}/>
                    <div style={{marginTop: '4px'}}>{filter.outstanding ?
                        <Chip key={"outstanding"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("outstanding")}
                              label={"Draft with previous versions"}/> : ""}</div>
                    <div style={{marginTop: '4px'}}>{filter.ucid ?
                        <Chip key={"ucid"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("ucid")} label={"UCID"}/> : ""}</div>
                    <div style={{width: filter.ucid ? "6px" : "0px"}}/>
                    <div style={{marginTop: '4px'}}>{filter.questionnaire ?
                        <Chip key={"questionnaire"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("questionnaire")} label={"Questionnaire"}/> : ""}</div>
                    <div style={{width: filter.outstanding ? "6px" : "0px"}}/>
                    <div style={{marginTop: '4px'}}>{filter.keyMetric !== "" ?
                        <Chip key={"keyMetric"} variant="outlined" sx={{backgroundColor: chipBgColor}}
                              onDelete={() => deleteChip("keyMetric")} label={"Key Metric"}/> : ""}</div>
                    <div style={{width: filter.keyMetric !== "" ? "6px" : "0px"}}/>
                    <div>{props.filter}</div>
                </div> : ""}
            </div>

            {props.children}
        </div>
    );
};

TableViewHook.defaultProps = {
    integrationID: null
};

TableViewHook.propTypes = {
    children: PropTypes.object,
    currentPath: PropTypes.string,
    filter: PropTypes.object,
    setFilter: PropTypes.func,
    pageState: PropTypes.func,
    templateType: PropTypes.string,
    templateMode: PropTypes.string,
    setLoadingState: PropTypes.func,
    integrationID: PropTypes.number
};

function mapStateToProps(state, props) {
    let filterName = TEMPLATE.FILTER[props.templateMode][props.templateType];
    return {
        pageFilter: props.filter !== undefined ? state.filter[filterName] : state.filter // Use templateType & Mode to get name of filter
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            setFilter,
            clearQuestionTemplateSearchTags,
            getIntegrationLogs
        }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TableViewHook);


// ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ

//  let screenHeight = window.screen.height;
//
// let cardHeaderSize = 100;
// let cardBodySize = 10 * 50;
// let cardFooterSize = 60;
// let cardHeight = (cardHeaderSize + cardBodySize + cardFooterSize) + "px";
//
//  let test = "Total width/height: " + window.screen.width + "*" + window.screen.height + "<br>" +
//      "Available width/height: " + window.screen.availWidth + "*" + window.screen.availHeight + "<br>" +
//      "Color depth: " + window.screen.colorDepth + "<br>" +
//      "Color resolution: " + window.screen.pixelDepth;
//
//  let userAgent = navigator.userAgent;
//  let browserName;
//
//  if (userAgent.match(/chrome|chromium|crios/i)){
//      browserName = "chrome";
//  }else if (userAgent.match(/firefox|fxios/i)){
//      browserName = "firefox";
//  }  else if (userAgent.match(/safari/i)){
//      browserName = "safari";
//  }else if (userAgent.match(/opr\//i)){
//      browserName = "opera";
//  } else if (userAgent.match(/edg/i)){
//      browserName = "edge";
//  }else{
//      browserName="No browser detection";
//  }

//var user = window.detect.parse(window.navigator.userAgent);
